<template>
  <div id="app">
    <nav v-if="showNav">
      <router-link v-if="showDashboardLink" to="/dashboard" class="nav-button">
        Dashboard
      </router-link>
    </nav>

    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  computed: {
    showNav() {
      // if you want to hide the entire nav on some pages later, extend this
      return true;
    },
    showDashboardLink() {
      return !this.$route?.meta?.hideDashboardLink;
    },
  },
};
</script>

<style>
/* Import Poppins from Google Fonts */
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600;800;900&display=swap");

html,
body {
  height: 100%;
  margin: 0;
}

body {
  font-family: "Poppins", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1f2a35; /* aligns with your dashboard palette */
}

/* Let pages control alignment and spacing */
#app {
  min-height: 100%;
}

/* Optional legacy nav styling (only matters if you still use <nav>) */
nav ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

nav ul li {
  display: inline;
  margin: 0 15px;
}

nav ul li a {
  font-weight: 700;
  color: #327ba8;
  text-decoration: none;
}

nav ul li a:hover {
  color: #286c98;
}

.ll-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 12px;
  border-radius: 999px;
  font-weight: 800;
  text-decoration: none;
  color: white;
  background: #327ba8;
  border: 1px solid rgba(50, 123, 168, 0.25);
  cursor: pointer;
}

.ll-pill:hover {
  background: #286c98;
}

.ll-pill.ghost {
  background: #4f6773;
}
.ll-pill.ghost:hover {
  background: #3a4a5e;
}


</style>
